import { render } from "./courseInfo.vue?vue&type=template&id=1a5f9b7f&scoped=true"
import script from "./courseInfo.vue?vue&type=script&lang=js"
export * from "./courseInfo.vue?vue&type=script&lang=js"

import "./courseInfo.vue?vue&type=style&index=0&id=1a5f9b7f&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5f9b7f"]])

export default __exports__